import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, makeStyles } from '@material-ui/core';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';
import ModalStandart from '../Modal';




interface EstadoTernarioProps {
  item: {
    estado: string;
  },
  info: {
    nombre: string;
    nombrePServicio: string;
    nroLegajo: string;
    fecha: null;
    entrada: null;
    salida: null;
    idMarcacion: number;
    entrada_id: number;
    salida_id: number;
    tipoMarcacion: string;
    tipoHora: string;
    total: null
  }
}



const useStyles = makeStyles((theme) => ({
  root:{
    padding: '20px',
    margin: theme.spacing(2)
  },
  text: {
    color: 'white',
  },
  colorModal: {
    color: 'black',
    margin: theme.spacing(3),
  },
  button: {
    backgroundColor: '#900533',
    width: '80%',
    margin: theme.spacing(3),
  },
  buttonGroup: {
    alignContent: 'space-between',
    width: '100%',
    marginTop: '15px',
  
  },
  ico: {
    color: 'white',
    fontSize: '30px',
    marginBottom: '10px',
    borderRadius: '50%',
    backgroundColor: '#900533',
    padding: '3px',
    cursor: 'pointer',
  },
  input: {
    margin: theme.spacing(1),
  },
}
));

const EstadosGestionMarcacion: React.FC<EstadoTernarioProps> = ({ item, info }) => {
  const classes = useStyles();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);
  const [textoModal, setTextoModal] = useState<string>('');
  const history = useHistory();
 

  const handleRedirectSalida = (info: any) => {
    const dato = JSON.stringify(info)
    history.push({
      pathname: '/gestionMarcacionSalida',
      state: dato,
    });
  };

  const handleRedirectEntrada = (info: any) => {
    const dato = JSON.stringify(info)
    history.push({
      pathname: '/gestionMarcacionEntrada',
      state: dato,
    });
  };


  const handleRedirectSupera = (info: any) => {

    const dato = JSON.stringify(info)
    history.push({
      pathname: '/gestionMarcacionSupera',
      state: dato,
    });
  };
  

  const handleCloseModal = () => {
    setModalVisible(false);
    setModalContent(null);
    setTextoModal('');
  };

  const renderEstado = (estado: string, text: string) => {
    switch (estado) {
      case 'SIN-ENTRADA':
        text = 'Sin entrada';
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CreateOutlinedIcon
             className={classes.ico}
              onClick={() => handleRedirectEntrada({info})}
            />
            {text}
          </div>
        );

      case 'SIN-SALIDA':
        text = 'Sin salida';
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CreateOutlinedIcon
             className={classes.ico}
              onClick={() => handleRedirectSalida({info})}
            />
            {text}
          </div>
        );

      case 'SUPERA':
        text = 'Supera';
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TrendingUpOutlinedIcon
             className={classes.ico}
              onClick={() => handleRedirectSupera({info})}
            />
            {text}
          </div>
        );

      case 'SIN-ASIGNACION':
        text = 'Debe gestionar la asignación';
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography>{text}</Typography>
          </div>
        );

      default:
        return null;
    }
  };

  const { estado } = item;

  return (
    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
      {renderEstado(estado, textoModal)}
      {modalVisible && modalContent && (
        <ModalStandart
          className={classes.colorModal}
          onClose={handleCloseModal}
          text={textoModal}
          body={() => modalContent}
        />
      )}
    </div>
  );
};

export default EstadosGestionMarcacion;